<template>
  <section class="rewards-item">
    <img :src="src" :alt="alt" />
    <div>
      <p v-for="paragraph in paragraphs" :key="paragraph">{{ paragraph }}</p>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    paragraphs: Array,
    src: String,
    alt: String,
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors';
@import '~@/assets/styles/breakpoints';

.rewards-item {
  display: flex;
  width: 50%;
  padding-right: 10px;
  justify-content: flex-start;
  align-items: flex-start;
}

@media (max-width: $page-mobile-large-breakpoint) {
  .rewards-item {
    width: 100%;
  }
}

img {
  margin-right: 15px;
  margin-top: 4px;
}

p {
  margin-bottom: 15px;
}

p:last-of-type {
  margin-bottom: 60px;
}
</style>
